'use strict'

module.exports = locate

function locate(value, fromIndex) {
  var index = value.indexOf('_', fromIndex)
  // return if part of emoji token
  // this type of logic should potentially go in tokenizer instead but couldn't get that to work
  if (index > -1 && value.indexOf(":") > -1) {
    return -1
  }
  return index
}
